<ng-template #modalTemplate>
  <button
    type="button"
    class="info-modal-close"
    aria-label="Close"
    (click)="modalRef.close()"
  >
    <svg-icon
      class="icon-close"
      [src]="'../../../assets/images/icons/close.svg'"
    ></svg-icon>
  </button>
  <div class="modal-content-holder">
    <h4 class="modal-title" *ngIf="title">{{ title | msg | async }}</h4>
    <div class="d-flex flex-row justify-content-end">
      <app-language-switch></app-language-switch>
      <app-profile-menu-switch
        (emitSignOut)="signOut()"
        *ngIf="showProfile"
      ></app-profile-menu-switch>
    </div>

    <ul class="list-group list-group-flush">
      <li
        class="list-group-item"
        [ngClass]="toUpperCase ? 'text-uppercase' : null"
        *ngFor="let item of items"
      >
        <a
          *ngIf="item.type !== navItemType.Button"
          [href]="item.navigateTo"
          class="nav-link"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          >{{ item.name | msg | async }}</a
        >
        <button
          *ngIf="item.type === navItemType.Button"
          [class]="item.class"
          (click)="item?.onClick()"
        >
          {{ item.name | msg }}
        </button>
      </li>
    </ul>
  </div>
</ng-template>
